var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 19C1.14433 18.0463 1 17.04 1 16C1 9.92487 5.92487 5 12 5C18.0751 5 23 9.92487 23 16C23 17.04 22.8557 18.0463 22.5859 19M9.76389 20C9.28885 19.4692 9 18.7684 9 18C9 16.3431 10.3431 15 12 15C13.6569 15 15 16.3431 15 18C15 18.7684 14.7111 19.4692 14.2361 20M14 15.0542L16.8958 11",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgDashboard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xLjQxNDA2IDE5QzEuMTQ0MzMgMTguMDQ2MyAxIDE3LjA0IDEgMTZDMSA5LjkyNDg3IDUuOTI0ODcgNSAxMiA1QzE4LjA3NTEgNSAyMyA5LjkyNDg3IDIzIDE2QzIzIDE3LjA0IDIyLjg1NTcgMTguMDQ2MyAyMi41ODU5IDE5TTkuNzYzODkgMjBDOS4yODg4NSAxOS40NjkyIDkgMTguNzY4NCA5IDE4QzkgMTYuMzQzMSAxMC4zNDMxIDE1IDEyIDE1QzEzLjY1NjkgMTUgMTUgMTYuMzQzMSAxNSAxOEMxNSAxOC43Njg0IDE0LjcxMTEgMTkuNDY5MiAxNC4yMzYxIDIwTTE0IDE1LjA1NDJMMTYuODk1OCAxMSIKICAgICAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";